<div class="create-report-category-page">
    <div class="page-header">
        <div class="d-flex justify-content-between align-items-center">
            <div>
                <h1 class="page-title">ASIGNAR REPORTE A CATEGORÍA</h1>
                <p class="page-subtitle text-muted">
                    Seleccione un reporte de Power BI y asígnelo a una categoría
                    KPI.
                </p>
            </div>
        </div>
    </div>
    <div class="page-content">
        <mat-card class="form-card">
            <mat-card-content>
                <!-- Loading reports -->
                <div *ngIf="isLoadingReports" class="loading-reports">
                    <mat-spinner diameter="30"></mat-spinner>
                    <span>Cargando reportes de Power BI...</span>
                </div>

                <form
                    *ngIf="!isLoadingReports"
                    [formGroup]="form"
                    (ngSubmit)="onSubmit()"
                >
                    <!-- Selección de Reporte -->
                    <div class="form-section">
                        <h6
                            class="section-title d-flex align-items-center mb-3"
                        >
                            <i
                                class="ri-bar-chart-box-line me-2 text-primary"
                            ></i>
                            Asignación
                        </h6>
                        <div class="form-grid basic-grid">
                            <mat-form-field
                                appearance="outline"
                                class="form-field"
                            >
                                <mat-label>Reporte Power BI</mat-label>
                                <mat-select formControlName="reportId">
                                    <mat-option
                                        *ngFor="let report of availableReports"
                                        [value]="report.id"
                                    >
                                        {{ report.name }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="
                                        form
                                            .get('reportId')
                                            ?.hasError('required')
                                    "
                                    >{{ getError('reportId') }}</mat-error
                                >
                                <mat-hint
                                    >Seleccione el reporte a
                                    categorizar</mat-hint
                                >
                            </mat-form-field>
                            <mat-form-field
                                appearance="outline"
                                class="form-field"
                            >
                                <mat-label>Categoría</mat-label>
                                <mat-select formControlName="category">
                                    <mat-option
                                        *ngFor="let cat of categories"
                                        [value]="cat.value"
                                    >
                                        {{ cat.label }}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="
                                        form
                                            .get('category')
                                            ?.hasError('required')
                                    "
                                    >{{ getError('category') }}</mat-error
                                >
                                <mat-hint
                                    >Operativo, Financiero o Gerencial</mat-hint
                                >
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Botones de acción -->
                    <div class="form-actions">
                        <button
                            type="button"
                            mat-button
                            (click)="onCancel()"
                            [disabled]="isLoading"
                        >
                            <i class="ri-arrow-left-line me-2"></i>
                            Cancelar
                        </button>
                        <button
                            type="submit"
                            mat-raised-button
                            color="primary"
                            [disabled]="form.invalid || isLoading"
                        >
                            <span *ngIf="!isLoading">
                                <i class="ri-add-line me-2"></i>
                                Asignar
                            </span>
                            <span *ngIf="isLoading">
                                <i
                                    class="ri-loader-4-line animate-spin me-2"
                                ></i>
                                Asignando...
                            </span>
                        </button>
                    </div>
                </form>
            </mat-card-content>
        </mat-card>
    </div>
</div>
